import { noop } from '@noshiro/ts-utils';
export const toSubscriber = (onNext, onComplete) => ({
    onNext,
    onComplete: onComplete !== null && onComplete !== void 0 ? onComplete : noop,
});
